import { AccountingFirmSidebar } from "@/components/shared/app-navigation/sidebar";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren;

export const AccountingFirmLayout = ({ children }: Props) => {
  return (
    <div className="flex min-h-screen w-full">
      <AccountingFirmSidebar />
      <main className="flex-1 relative w-full h-screen overflow-hidden">
        {children}
      </main>
    </div>
  );
};
